import React from 'react'
import {
  compose,
  withHandlers,
  withPropsOnChange,
  lifecycle,
  withStateHandlers,
} from 'recompose'
import { connect } from 'react-redux'
import { change, getFormValues } from 'redux-form'
import * as R from 'ramda'
import get from 'lodash/get'

import RadioButton from '@infotech/uikit-radiobutton'
import { getResponseEntities } from '@infotech/lib-api-middleware'

import { ISSUE_LINK_SYSTEM_TYPE } from './constants'
import IssueLinkSelect from './IssueLinkSelect/index'
import {
  withEsuzIssueOnSelect,
} from './withEsuzIssue'
import {
  withToirIssueOnSelect,
} from './withToirIssue'
import withConfig from './hocs/withConfig'


const enhance = compose(
  withStateHandlers({
    autocompleteKey: ``,
    data           : [],
    busy           : false,
  }, {
    setAutocompleteKey : () => (autocompleteKey) => ({ autocompleteKey }),
    setAutocompleteData: () => (data) => ({ data }),
    setBusy            : () => (busy) => ({ busy }),
  }),
  connect(
    (state, { meta: { form } }) => ({
      issueLinkSystemType: R.prop(`esuzSystemType`, getFormValues(form)(state)) || ISSUE_LINK_SYSTEM_TYPE.ahp,
    }),
    (dispatch, { meta: { form } }) => ({
      changeFormValue: (field, value) => dispatch(change(form, field, value)),
    }),
  ),
  withToirIssueOnSelect,
  withEsuzIssueOnSelect,
  withConfig,
  connect(
    null,
    (dispatch, {
      setAutocompleteData,
      setBusy,
      apiAction,
      entityName,
      transformLoadData,
    }) => ({
      getAutocompleteData: (params) => {
        setBusy(true)
        dispatch(apiAction(params)).then((res) => {
          setBusy(false)
          if (!res.error) {
            let data = getResponseEntities(res, entityName)
            if (transformLoadData && R.is(Function, transformLoadData)) {
              data = transformLoadData(data)
            }
            setAutocompleteData(data)
          }
        })
      },
    }),
  ),
  withHandlers({
    onChange: ({
      setAutocompleteKey,
      getAutocompleteData,
      setAutocompleteData,
      input: { onChange, value },
      changeFormValue,
    }) => (newValue) => {
      // для предотвращения доп. запроса при клике на опцию
      if (typeof newValue === `object`) {
        return
      }
      setAutocompleteData([])
      setAutocompleteKey(newValue)
      if ((newValue === ``) && value) {
        onChange(newValue)
        changeFormValue(`objectId`, ``)
        changeFormValue(`object`, ``)
      } else {
        getAutocompleteData(newValue)
      }
    },
    onSelect: ({
      input: { onChange },
      changeFormValue,
      valueField,
      textField,
      setAutocompleteKey,
    }) => (value) => {
      setAutocompleteKey(``)
      onChange(get(value, textField, ``))
      changeFormValue(`esuz`, get(value, valueField, ``))
    },
  }),
  withHandlers({
    handleChange: ({ changeFormValue, setAutocompleteData }) => (esuzSystemType) => {
      setAutocompleteData([])
      changeFormValue(`esuzSystemType`, esuzSystemType)
      changeFormValue(`esuz`, ``)
      changeFormValue(`esuzNumber`, ``)
      changeFormValue(`objectId`, ``)
      changeFormValue(`object`, ``)
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        changeFormValue,
        issueLinkSystemType,
      } = this.props
      if (issueLinkSystemType === ISSUE_LINK_SYSTEM_TYPE.ahp) {
        changeFormValue(`esuzSystemType`, ISSUE_LINK_SYSTEM_TYPE.ahp)
      }
    },
  }),
  withPropsOnChange([`issueLinkSystemType`], ({
    autocompleteKey,
    onChange,
  }) => {
    if (autocompleteKey) {
      onChange(autocompleteKey)
    }
  }),
)

const IssueLinkField = ({
  handleChange,
  input,
  meta,
  issueLinkSystemType,
  ...restProps
}) => (
  <>
    <RadioButton.HorizontalGroup
      value={issueLinkSystemType}
    >
      <RadioButton
        label="ЕСУЗ"
        value={ISSUE_LINK_SYSTEM_TYPE.ahp}
        onChange={() => handleChange(ISSUE_LINK_SYSTEM_TYPE.ahp)}
      />
      <RadioButton
        label="ТОИР"
        value={ISSUE_LINK_SYSTEM_TYPE.toir}
        onChange={() => handleChange(ISSUE_LINK_SYSTEM_TYPE.toir)}
      />
    </RadioButton.HorizontalGroup>
    <IssueLinkSelect
      input={input}
      meta={meta}
      issueLinkSystemType={issueLinkSystemType}
      {...restProps}
    />
  </>
)

export default enhance(IssueLinkField)
